import { Badge, Box, Heading, Stack, Text } from 'braid-design-system';

interface Props {
  name: string;
  date?: string;
  image?: string;
  nextEvent?: boolean;
  onClick: () => void;
}

export const EventBlock = ({
  name,
  date,
  image,
  nextEvent,
  onClick,
}: Props) => (
  <Box
    component="button"
    type="button"
    cursor="pointer"
    onClick={onClick}
    display="block"
    width="full"
    padding="none"
    borderRadius="large"
    style={{
      appearance: 'none',
      background: 'transparent',
      border: 'none',
      textAlign: 'left',
    }}
  >
    <Box
      paddingY="medium"
      borderRadius="large"
      height="full"
      boxShadow={nextEvent ? 'borderPositiveLight' : 'borderNeutralLight'}
      background={nextEvent ? 'positiveLight' : 'body'}
    >
      <Box
        style={{
          paddingLeft: '160px',
          minHeight: '128px',
          backgroundImage: image ? `url(${image})` : undefined,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '12px 50%',
          backgroundSize: '128px auto',
        }}
      >
        <Stack space="medium">
          {nextEvent && (
            <Badge tone="caution" weight="strong">
              What&apos;s next?
            </Badge>
          )}
          <Heading level="3">
            <span style={{ fontWeight: 600 }}>{name}</span>
          </Heading>

          <Box>{date ? <Text>{date}</Text> : null}</Box>
        </Stack>
      </Box>
    </Box>
  </Box>
);
